// @flow

import Button, { FakeButton, LinkButton } from './button';
import ACFButton from './button.acf';
import withMacrosButton from './withMacrosButton';
import type {
  ACFProps,
  Template,
  Position,
} from './types';

export type {
  ACFProps,
  Template,
  Position,
};

export {
  FakeButton,
  ACFButton,
  LinkButton,
  withMacrosButton,
};

export default Button;
